import { _ } from '@ngx-translate/core';

import { DiscountTypeItem } from './types';

export const DISCOUNT_TYPE_NAMES: Record<DiscountTypeItem, string> = {
  rate: _('components.loyaltyTermsStep.discountType.rate'),
  cash: _('components.loyaltyTermsStep.discountType.cash'),
  tag: _('components.loyaltyTermsStep.discountType.tag'),
} as const;
